// extracted by mini-css-extract-plugin
export default {"score":"Score_score__SduZY","card":"Score_card__fYK5F"};